/* eslint-disable react/jsx-fragments */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Title from './Title';
import Text from './Text';
import ShareTitle from './ShareTitle';
export default (function () {
  return React.createElement(React.Fragment, null, React.createElement(FormattedMessage, {
    id: "hummingbird.CampaignConfirmed.main.eventTitle",
    description: "Title of campaign submission success.",
    defaultMessage: "Hurray!",
    tagName: Title
  }), React.createElement(FormattedMessage, {
    id: "hummingbird.CampaignConfirmed.main.eventText",
    description: "Text of campaign submission success.",
    defaultMessage: "Thanks to you, we are one step closer towards our goals.",
    tagName: Text
  }));
});
export var EventShareTitle = function EventShareTitle() {
  return React.createElement(FormattedMessage, {
    id: "hummingbird.CampaignConfirmed.main.eventShareTitle",
    description: "Title above campaign share buttons.",
    defaultMessage: "Please share this event with your friends and colleagues:",
    tagName: ShareTitle
  });
};